import Swiper, { Autoplay, Navigation, Scrollbar } from 'swiper';
import { swiperObserver } from '../utils/swiper.utils.js';


let spotlightSwiperWr = document.querySelectorAll('.spotlight-swiper-wr');

spotlightSwiperWr.forEach((el) => {
  if (el) {
    let swiperEl = el.querySelector('.swiper');
    let parentEl = el.parentElement;
    let nextEl = parentEl.querySelector('.swiper-button-next');
    let prevEl = parentEl.querySelector('.swiper-button-prev');
    let scrollbarEl = parentEl.querySelector('.spotlight-sec__scrollbar');
    let slidesCount = el.querySelectorAll('.swiper-slide').length;
    let wrapper = swiperEl.querySelector('.swiper-wrapper');


    let swiper = new Swiper(swiperEl, {
      modules: [Autoplay, Navigation, Scrollbar],
      observer: true, //needs to calculate swiper size
      observeParents: true, //needs to calculate swiper size
      spaceBetween: 12,
      slidesPerView: 1.05,
      threshold: 10,
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },
      scrollbar: {
        el: scrollbarEl,
        draggable: true,
      },
      breakpoints: {
        375: {
          spaceBetween: 12,
          slidesPerView: 1.18,
        },
        440: {
          spaceBetween: 16,
          slidesPerView: 1.3,
        },
        768: {
          spaceBetween: 16,
          slidesPerView: 1.6,
        },
        840: {
          spaceBetween: 16,
          slidesPerView: 2,
        },
        1280: {
          spaceBetween: 20,
          slidesPerView: 2.5,
        },
      },
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
        pauseOnMouseEnter: window.innerWidth >= 640,
      },
    });
    swiperObserver(swiper);
  }
});